// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IDelinquentClaimsMultiEmployersSummaryRecordDto } from './IDelinquentClaimsMultiEmployersSummaryRecordDto';
import {
    IDelinquentClaimsMultiEmployersSummaryRecordDtoFromJSON,
    IDelinquentClaimsMultiEmployersSummaryRecordDtoFromJSONTyped,
    IDelinquentClaimsMultiEmployersSummaryRecordDtoToJSON,
    IDelinquentClaimsMultiEmployersSummaryRecordDtoToJSONTyped,
} from './IDelinquentClaimsMultiEmployersSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDto
 */
export interface IReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {Array<IDelinquentClaimsMultiEmployersSummaryRecordDto>}
     * @memberof IReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDto
     */
    subsidiary_records?: Array<IDelinquentClaimsMultiEmployersSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDto(value: object): value is IReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDto {
    return true;
}

export function IReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDtoFromJSON(json: any): IReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDto {
    return IReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'subsidiary_records': json['subsidiary_records'] == null ? undefined : ((json['subsidiary_records'] as Array<any>).map(IDelinquentClaimsMultiEmployersSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDtoToJSON(json: any): IReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDto {
    return IReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDtoToJSONTyped(value?: IReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subsidiary_name': value['subsidiary_name'],
        'subsidiary_records': value['subsidiary_records'] == null ? undefined : ((value['subsidiary_records'] as Array<any>).map(IDelinquentClaimsMultiEmployersSummaryRecordDtoToJSON)),
    };
}

